var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9280_5678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.976 22.3252L20.6156 28.1213C20.8112 28.2696 21.0081 28.3482 21.185 28.3482C21.3654 28.3482 21.5228 28.2664 21.6281 28.118C21.7288 27.9763 21.7799 27.7829 21.7799 27.5432L21.7799 25.324C21.7799 24.7402 22.2549 24.2652 22.8387 24.2652L29.1405 24.2651C29.8716 24.2651 30.4665 23.6701 30.4665 22.9392L30.4665 20.0574C30.4665 19.3265 29.8716 18.7315 29.1405 18.7315L22.8387 18.7315C22.2549 18.7315 21.7799 18.2565 21.7799 17.6726L21.7799 15.4533C21.7799 14.86 21.4726 14.6484 21.1851 14.6484C21.0082 14.6484 20.8113 14.727 20.6157 14.8754L12.9761 20.6715C12.6892 20.889 12.5313 21.1827 12.5313 21.4986C12.5312 21.8141 12.6891 22.1078 12.976 22.3252Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 -3.75915e-06C9.64476 -1.68634e-06 1.68634e-06 9.64476 3.75918e-06 21.5C5.83201e-06 33.3552 9.64477 43 21.4998 43C33.3549 43 42.9997 33.3552 42.9997 21.5C42.9997 9.64476 33.3549 -5.83196e-06 21.4998 -3.75915e-06ZM21.4998 5.60889C30.2623 5.60889 37.391 12.7374 37.391 21.5C37.391 30.2626 30.2623 37.3911 21.4998 37.3911C12.7374 37.3911 5.60857 30.2626 5.60856 21.5C5.60856 12.7374 12.7375 5.60889 21.4998 5.60889Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9280_5678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7b9e7d87ddc45094c100a0bbbe88a137.svg";
export { ForwardRef as ReactComponent };